import React, { FC, memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MobileNowPlayingModal.scss';

interface MobileCreditsCardProps {
  song: Spotify.Track;
  onCloseParent: () => void;
}

export const MobileCreditsCard: FC<MobileCreditsCardProps> = memo(({ song, onCloseParent }) => {
  const navigate = useNavigate();
  const [followingMap, setFollowingMap] = useState<Record<string, boolean>>({});

  const toggleFollow = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setFollowingMap((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const artists = song.artists || [];
  const mainArtist = artists[0];
  const otherArtists = artists.slice(1);

  return (
    <div className='mnp-credits-card'>
      {/* Header */}
      <div className='mnp-credits-header'>
        <h3 className='mnp-credits-title'>Credits</h3>
        <span className='mnp-credits-show-all' onClick={() => {
          const firstId = (mainArtist as any)?.id || mainArtist?.uri?.split(':').reverse()[0];
          if (firstId) {
            navigate(`/artist/${firstId}`);
            onCloseParent();
          }
        }}>
          Show all
        </span>
      </div>

      {/* Main Artist Row */}
      {mainArtist && (
        <div
          className='mnp-credit-row'
          onClick={() => {
            const firstId = (mainArtist as any)?.id || mainArtist?.uri?.split(':').reverse()[0];
            if (firstId) {
              navigate(`/artist/${firstId}`);
              onCloseParent();
            }
          }}
        >
          <div className='mnp-credit-info'>
            <p className='mnp-credit-name'>{mainArtist.name}</p>
            <p className='mnp-credit-role'>Main Artist • Performer</p>
          </div>

          <button
            className={`mnp-credit-follow-btn ${followingMap[(mainArtist as any).id || mainArtist.name] ? 'following' : ''}`}
            onClick={(e) => toggleFollow((mainArtist as any).id || mainArtist.name, e)}
          >
            {followingMap[(mainArtist as any).id || mainArtist.name] ? 'Following' : 'Follow'}
          </button>
        </div>
      )}

      {/* Other Artists / Writers */}
      {otherArtists.map((artist, idx) => (
        <div
          key={artist.uri || idx}
          className='mnp-credit-row'
          onClick={() => {
            const id = (artist as any)?.id || artist.uri?.split(':').reverse()[0];
            if (id) {
              navigate(`/artist/${id}`);
              onCloseParent();
            }
          }}
        >
          <div className='mnp-credit-info'>
            <p className='mnp-credit-name'>{artist.name}</p>
            <p className='mnp-credit-role'>Featured Artist • Writer</p>
          </div>

          <button
            className={`mnp-credit-follow-btn ${followingMap[(artist as any).id || artist.name] ? 'following' : ''}`}
            onClick={(e) => toggleFollow((artist as any).id || artist.name, e)}
          >
            {followingMap[(artist as any).id || artist.name] ? 'Following' : 'Follow'}
          </button>
        </div>
      ))}

      {/* Album / Label Writer Row */}
      {song.album && (
        <div className='mnp-credit-row'>
          <div className='mnp-credit-info'>
            <p className='mnp-credit-name'>{song.album.name}</p>
            <p className='mnp-credit-role'>Original Release • Producer</p>
          </div>
        </div>
      )}
    </div>
  );
});

MobileCreditsCard.displayName = 'MobileCreditsCard';
export default MobileCreditsCard;
